
// 自定义主题配置
const customTheme = {
  token: {
    // 颜色
    colorPrimary: '#4361ee', // 主色调，现代蓝色
    colorSuccess: '#4cc9f0', // 成功色，亮蓝色
    colorWarning: '#f72585', // 警告色，亮粉色
    colorError: '#ff5a5f', // 错误色，珊瑚红
    colorInfo: '#3a0ca3', // 信息色，深紫色
    
    // 背景色
    colorBgContainer: '#ffffff', // 容器背景色，白色
    colorBgElevated: '#f8f9fa', // 浮层背景色，浅灰色
    colorBgLayout: '#f0f2f5', // 布局背景色，浅灰色
    
    // 文本色
    colorText: '#212529', // 主文本色，深灰色
    colorTextSecondary: '#6c757d', // 次要文本色，中灰色
    colorTextTertiary: '#adb5bd', // 第三级文本色，浅灰色
    
    // 边框
    colorBorder: '#e9ecef', // 边框色，浅灰色
    borderRadius: 8, // 边框圆角
    borderRadiusLG: 12, // 大号边框圆角
    
    // 字体
    fontFamily: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", sans-serif',
    fontSize: 14, // 基础字体大小
    
    // 阴影
    boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
    boxShadowSecondary: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12)',
  },
  // 组件样式覆盖
  components: {
    Button: {
      colorPrimary: '#4361ee',
      algorithm: true, // 启用算法
    },
    Card: {
      colorBgContainer: '#ffffff',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
      borderRadiusLG: 12,
    },
    Table: {
      colorBgContainer: '#ffffff',
      headerBg: '#f8f9fa',
      headerColor: '#212529',
      borderColor: '#e9ecef',
      rowHoverBg: '#f8f9fa',
    },
    Select: {
      colorBorder: '#e9ecef',
      controlItemBgActive: '#e9ecef',
    },
    Input: {
      colorBorder: '#e9ecef',
    },
    Menu: {
      darkItemBg: '#3a0ca3', // 深色菜单背景
      darkItemColor: '#ffffff', // 深色菜单文字颜色
      darkItemHoverBg: '#4361ee', // 深色菜单悬停背景
      darkItemSelectedBg: '#4361ee', // 深色菜单选中背景
    },
    Layout: {
      headerBg: '#3a0ca3', // 头部背景色
      bodyBg: '#f0f2f5', // 内容区背景色
    },
  },
};

export default customTheme;